import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Das Design System einmal global laden: Die Scrollbalken-Grundlage in
// components.css gilt fuer die ganze Anwendung und soll nicht davon abhaengen,
// welche Szene ihre Styles zuerst importiert.
import './design-system/styles/tokens.css';
import './design-system/styles/components.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './AuthContext';
import { createRoot } from 'react-dom/client';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5QdERiW31YdHVdTmdV');

const container = document.getElementById('root');
const root = createRoot(container); // Correct usage of createRoot
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);
